module.exports = __webpack_public_path__ + "1ac0540c2e17a0af85b2ded58f695eb3.jpg";